import React from 'react';
import { accountSearchColumns, customerSearchColumns, donViSearchColumns, QUERY_KEYS } from '@/constants';
import { FormFieldV2 as FormField, SearchFieldV2 as SearchField } from '@/components/custom/erp';
import { DonViCoSo, KhachHang, TaiKhoan } from '@/types/schemas';
import { Label } from '@/components/ui/label';

interface DetailTabProps {
  selectedKhachHang: KhachHang | null;
  setSelectedKhachHang: (value: KhachHang | null) => void;
  selectedTaiKhoanCo: TaiKhoan | null;
  setSelectedTaiKhoanCo: (value: TaiKhoan | null) => void;
  selectedDonVi: DonViCoSo | null;
  setSelectedDonVi: (value: DonViCoSo | null) => void;
}

export const DetailTab: React.FC<DetailTabProps> = ({
  selectedKhachHang,
  setSelectedKhachHang,
  selectedTaiKhoanCo,
  setSelectedTaiKhoanCo,
  selectedDonVi,
  setSelectedDonVi
}) => {
  return (
    <div className='space-y-3 p-4'>
      {/* Customer Search Field */}
      <div className='flex items-center gap-3'>
        <Label className='w-[150px] shrink-0 text-[13px]'>Mã khách hàng</Label>
        <SearchField<KhachHang>
          displayRelatedField='customer_name'
          columnDisplay='customer_code'
          searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}`}
          searchColumns={customerSearchColumns}
          dialogTitle='Danh mục khách hàng'
          value={selectedKhachHang?.customer_code}
          relatedFieldValue={selectedKhachHang?.customer_name}
          onRowSelection={setSelectedKhachHang}
          className='w-100'
        />
      </div>

      {/* Account Credit Search Field */}
      <div className='flex items-center gap-3'>
        <Label className='w-[150px] shrink-0 text-[13px]'>Tài khoản có</Label>
        <SearchField<TaiKhoan>
          displayRelatedField='code'
          columnDisplay='name'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
          searchColumns={accountSearchColumns}
          dialogTitle='Danh mục tài khoản'
          value={selectedTaiKhoanCo?.code}
          relatedFieldValue={selectedTaiKhoanCo?.name}
          onRowSelection={setSelectedTaiKhoanCo}
          className='w-100'
        />
      </div>

      {/* Unit Search Field */}
      <div className='flex items-center gap-3'>
        <Label className='w-[150px] shrink-0 text-[13px]'>Đơn vị</Label>
        <SearchField<DonViCoSo>
          displayRelatedField='ten_unit'
          columnDisplay='ma_unit'
          searchEndpoint={`/${QUERY_KEYS.DON_VI}/`}
          searchColumns={donViSearchColumns}
          dialogTitle='Danh mục đơn vị cơ sở'
          value={selectedDonVi?.ma_unit}
          relatedFieldValue={selectedDonVi?.ten_unit}
          onRowSelection={setSelectedDonVi}
          className='w-100'
        />
      </div>

      {/* Status Dropdown */}
      <div className='flex items-center gap-3'>
        <Label className='w-[150px] shrink-0 text-[13px]'>Trạng thái</Label>
        <div className='w-[280px]'>
          <FormField
            className='w-full'
            type='select'
            name='status'
            options={[
              { value: 'ALL', label: 'Tất cả' },
              { value: '1', label: 'Chưa ghi sổ' },
              { value: '3', label: 'Chờ duyệt' },
              { value: '5', label: 'Đã ghi sổ' },
              { value: '6', label: 'Đang thực hiện' },
              { value: '7', label: 'Hoàn thành' },
              { value: '8', label: 'Gửi tiền' },
              { value: '9', label: 'Hủy' }
            ]}
          />
        </div>
      </div>

      {/* Filter by User Dropdown */}
      <div className='flex items-center gap-3'>
        <Label className='w-[150px] shrink-0 text-[13px]'>Lọc theo người sử dụng</Label>
        <div className='w-[280px]'>
          <FormField
            className='w-full'
            type='select'
            name='user_id0'
            options={[
              { value: 'ALL', label: 'Tất cả' },
              { value: '1', label: 'Lọc theo người tạo' }
            ]}
          />
        </div>
      </div>
    </div>
  );
};
